import { FC, useEffect, useContext } from "react";
import { ProForm, ProInputNumber } from '../../antd';
import RowContext from "../context/rowContext";
import { formatRowKey } from "../util";
import MianSubTableContext, { IEdiTableContext } from '../context/mianSubTableContext';
import { STATUS_CREATED, STATUS_CREATED_CODE } from '../../constants/constant';
import { ADD_KEY, TableRowProps } from "../interface";

const TableRow: FC<TableRowProps> = props => {
  const { onValuesChange, disabled, record, ...restProps } = props;
  const [form] = ProForm.useForm();
  const dataRowKey = props['data-row-key'];
  const { dispatchEditSubTable, tableDataSource, } = useContext<IEdiTableContext>(MianSubTableContext);
  useEffect(() => {
    if (!dataRowKey) return;
    const {mainKey, childrenKey} = formatRowKey(dataRowKey);
    dispatchEditSubTable('addForm', { form, mainKey, childrenKey, });
    return () => {
      dispatchEditSubTable('deleteForm', { mainKey, childrenKey, });
    };
  }, []);
  const handleValuesChange = (changedValues: any, values: any) => {
    const findItem = tableDataSource?.find?.(v => v.key === dataRowKey);
    onValuesChange?.(
      Object.values(changedValues)[0],
      Object.keys(changedValues)[0],
      { ...findItem, ...values },
      dataRowKey,
      form,
      record,
    );
    form.setFieldsValue({ recordStatus: STATUS_CREATED.UPDATE });
  };
  if (dataRowKey === undefined) return <tr {...props}></tr>;
  if (dataRowKey.includes(ADD_KEY) && disabled) return null; 
  return (
    <ProForm
      form={form}
      name={`ediTable_${dataRowKey}`}
      component={false}
      onValuesChange={handleValuesChange}
    >
      <ProForm.Item name={STATUS_CREATED_CODE} hidden={true}>
        <ProInputNumber />
      </ProForm.Item>
      <RowContext.Provider value={form}>
        <tr {...restProps} />
      </RowContext.Provider>
    </ProForm>
  );
};

export default TableRow;
